import { render } from "./LoginPage.vue?vue&type=template&id=2babc2c5&ts=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Authentication/LoginPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2babc2c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2babc2c5', __exports__)) {
    api.reload('2babc2c5', __exports__)
  }
  
  module.hot.accept("./LoginPage.vue?vue&type=template&id=2babc2c5&ts=true", () => {
    api.rerender('2babc2c5', render)
  })

}


export default __exports__